import { render, staticRenderFns } from "./PopularPhrasesWordCloud.vue?vue&type=template&id=e15192f4"
import script from "./PopularPhrasesWordCloud.vue?vue&type=script&lang=ts"
export * from "./PopularPhrasesWordCloud.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports